export default "__VITE_ASSET__FtFNMM1M__"